import { useState } from 'react'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import Typography from '@mui/material/Typography'

interface ActivationKeyProps {
    value: string
}

/** A standalone license activation key in monospace with a copy-to-clipboard button. */
export const ActivationKey = ({ value }: ActivationKeyProps) => {
    const [copied, setCopied] = useState(false)

    const copy = async () => {
        try {
            await navigator.clipboard.writeText(value)
            setCopied(true)
        } catch {
            setCopied(false)
        }
    }

    return (
        <Stack direction="row" spacing={0.5} sx={{ alignItems: 'center' }}>
            <Typography component="code" sx={{ fontFamily: 'monospace', fontSize: '0.875rem' }}>
                {value}
            </Typography>
            <Tooltip title={copied ? 'Copied' : 'Copy activation key'} onClose={() => setCopied(false)}>
                <IconButton size="small" aria-label="Copy activation key" onClick={() => void copy()}>
                    <ContentCopyIcon fontSize="inherit" />
                </IconButton>
            </Tooltip>
        </Stack>
    )
}
